<img [src]="logo$|async" alt="logo-institucional" class="w-64 h-32 object-contain mobile:mx-auto animate__animated animate__fadeIn">
